var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('SignagePresentation',{key:_vm.presentationKey,attrs:{"is-public-resources":_vm.isPublicResources,"shop":_vm.shop,"facility":_vm.facility,"measures":_vm.measures,"shop-confirm-list":_vm.shopConfirmList,"trust-index":_vm.trustIndex,"sensor":_vm.sensor,"updated-at":_vm.updatedAt}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }